export const sellingPointsDynamic = [
  { icon: 'check', sellingPoint: 'offer.dynamic' },
  { icon: 'check', sellingPoint: 'offer.dynamic_security' },
  { icon: 'check', sellingPoint: 'offer.dynamic_insights' },
];
